import React, { useState } from "react";
import Modal from "../../components/Modal";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";

const RejectStockRequisition = ({ modalOpen, setModalOpen, item }) => {
  const { requestWithAuth } = useAuth();
  const [submittingForm, setSubmittingForm] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");

  const handleRejection = async (e) => {
    e.preventDefault();
    if (rejectionReason === "") {
      toast.error("Please specify why you want to reject this supply");
      return;
    }

    Swal.fire({
      icon: "question",
      title: "Are you sure you want to reject this supply?",
      showDenyButton: true,
      confirmButtonText: "Yes Proceed!",
    }).then(async (result) => {
      if (result.isConfirmed) {

        try {
          setSubmittingForm(true);
          const body = JSON.stringify({
            rejection_reason: rejectionReason,
          });
          const data = await requestWithAuth(
            `/inventory/requisition/branch/${item?.id}/item?action=reject`,
            "PUT",
            body,
            {
              "Content-Type": "application/json",
            }
          );
          Swal.fire({
            icon: "success",
            title: "Requested!",
            text: "Items Rejected Successfully",
          }).then(() => {
            window.location.reload();
          });
        } catch (error) {
          toast.error("Something went wrong!");
        } finally {
          setSubmittingForm(false);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <div>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Supply Details"
      >
        <form onSubmit={(e) => handleRejection(e)}>
          <div className="grid grid-cols-2 gap-5">
            <div className="flex flex-col gap-2 col-span-2">
              <label htmlFor="" className="font-bold">
                Drug Name
              </label>
              <input
                type="text"
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                value={item?.drug}
                disabled
              />
            </div>
            {/* <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Total Remaining
              </label>
              <input
                type="text"
                value={item?.total_remaining}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                disabled
              />
            </div> */}

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Total Requested
              </label>
              <input
                type="text"
                value={item?.quantity}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                disabled
              />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Total Supplied
              </label>
              <input
                type="number"
                required
                disabled
                min="0"
                value={item?.quantity_supplied}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
              />
            </div>
            <div className="flex flex-col gap-2 col-span-2">
              <label htmlFor="" className="font-bold">
                Rejection Reason
              </label>
              <textarea onChange={(e) => setRejectionReason(e.target.value)} name="rejection_reason" id="" className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]">

              </textarea>

            </div>
          </div>
          <div className="flex items-center justify-end gap-6 mt-7">
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              Close
            </div>
            {submittingForm ? (
              <div className="bg-blue-400 flex items-center gap-2 rounded px-4 py-2 text-white ">
                <RotatingLines strokeColor="white" height="12" width="12" />{" "}
                Submitting
              </div>
            ) : (
              <button className="bg-blue-500 hover:bg-blue-600 rounded px-4 py-2 text-white ">
                Submit Form
              </button>
            )}
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default RejectStockRequisition;
